import { forwardRef } from 'react'
import { TextField, type TextFieldProps } from '@mui/material'

export type TextboxProps = TextFieldProps

export const Textbox = forwardRef<HTMLInputElement, TextboxProps>(function Textbox({ fullWidth = true, variant = 'outlined', ...props }, ref) {
  return <TextField {...props} fullWidth={fullWidth} inputRef={ref} variant={variant} />
})
